import { Config, Schema } from 'effect'

import { PublicEnvironmentConfig } from './environment/public.environment.ts'

export const SharedSentryConfig = Config.all({
  dsn: Config.string('PUBLIC_SENTRY_DSN').pipe(Config.withDefault('')),
  release: Config.string('PUBLIC_SENTRY_RELEASE').pipe(Config.withDefault('')),
})

export const SharedSupabaseConfig = Config.all({
  publicUrl: PublicEnvironmentConfig.PUBLIC_SUPABASE_URL,
  anonKey: PublicEnvironmentConfig.PUBLIC_SUPABASE_ANON_KEY,
})

const Runtime = Schema.Union([
  Schema.Literal('browser'),
  Schema.Literal('nodejs'),
  Schema.Literal('edge'),
])
export type Runtime = typeof Runtime.Type
const isRuntime = Schema.is(Runtime)

export const SharedRuntimeConfig = Config.map(
  Config.all({
    runtime: Config.string('NEXT_RUNTIME'),
  }),
  ({ runtime }) => {
    if (globalThis.window) return { runtime: 'browser' as const }
    if (isRuntime(runtime)) return { runtime }
    return { runtime: 'nodejs' as const }
  },
)
